export const TEXTS_DATA = {
  INFO: 'Здесь будут формы, которые вы создатите',
};
